module.exports = __webpack_public_path__ + "img/big_1_7.64f82f9a.png";